import {Injectable, ApplicationRef, ComponentRef, EnvironmentInjector} from '@angular/core';
import { createComponent } from '@angular/core';
import {ModalComponent} from "@cybfed/ui-lib/modal/modal.component";

@Injectable({ providedIn: 'root' })
export class ModalService {
  public modalHostRef?: ComponentRef<ModalComponent>;

  constructor(
      private appRef: ApplicationRef,
      private environmentInjector: EnvironmentInjector
  ) {}

  openModal (componentType: any, data?: any, callbacks?: Record<string, any>) {
    if (!this.modalHostRef) {
      this.modalHostRef = createComponent(ModalComponent, {
        environmentInjector: this.environmentInjector
      });
      this.appRef.attachView(this.modalHostRef.hostView);
      document.body.appendChild(this.modalHostRef.location.nativeElement);

      // Subscribe to the close event
      this.modalHostRef.instance.closeRequested.subscribe(() => {
        this.closeModal();
      });
    }

    return this.modalHostRef.instance.open(componentType, data, callbacks);
  }

  closeModal() {
    if (this.modalHostRef) {
      this.modalHostRef.instance.close();
      this.appRef.detachView(this.modalHostRef.hostView);
      this.modalHostRef.location.nativeElement.remove();
      this.modalHostRef = undefined;
    }
  }
}
